import { render, staticRenderFns } from "./ITManager.vue?vue&type=template&id=3828252c&scoped=true&"
import script from "./ITManager.vue?vue&type=script&lang=js&"
export * from "./ITManager.vue?vue&type=script&lang=js&"
import style0 from "./ITManager.vue?vue&type=style&index=0&id=3828252c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3828252c",
  null
  
)

export default component.exports